exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".MoreIcon__container__a8uNt{width:16px;display:-ms-flexbox;display:flex;-ms-flex-pack:justify;justify-content:space-between}.MoreIcon__container__a8uNt span{width:4px;height:4px;border-radius:50%;background-color:#a8aab7}.MoreIcon__container__a8uNt span.MoreIcon__active__2QpNK{background-color:#33333d}", "", {"version":3,"sources":["/mnt/d/asofts/vvs/cirrus/Cirrus/frontend/src/components/assets/icons/src/components/assets/icons/MoreIcon.scss"],"names":[],"mappings":"AAAA,4BACE,WAAW,AACX,oBAAa,AAAb,aAAa,AACb,sBAA8B,AAA9B,6BAA8B,CAc/B,AAjBD,iCAMI,UAAU,AACV,WAAW,AAEX,kBAAkB,AAElB,wBAAyB,CAK1B,AAhBH,yDAcM,wBAAyB,CAC1B","file":"MoreIcon.scss","sourcesContent":[".container {\n  width: 16px;\n  display: flex;\n  justify-content: space-between;\n\n  span {\n    width: 4px;\n    height: 4px;\n\n    border-radius: 50%;\n\n    background-color: #a8aab7;\n\n    &.active {\n      background-color: #33333d;\n    }\n  }\n}"],"sourceRoot":""}]);

// exports
exports.locals = {
	"container": "MoreIcon__container__a8uNt",
	"active": "MoreIcon__active__2QpNK"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--1-2!./node_modules/sass-loader/lib/loader.js??ref--1-3!./src/components/assets/icons/MoreIcon.scss
// module id = ./node_modules/css-loader/index.js??ref--1-2!./node_modules/sass-loader/lib/loader.js??ref--1-3!./src/components/assets/icons/MoreIcon.scss
// module chunks = 0